module.exports = __webpack_public_path__ + "img/3fjlz-l20-130_130.prt.0c07e993.jpg";